import React from 'react';
import PropTypes from 'prop-types';

const PlusIcon = ({ color = '#C70000', width = 7, height = 14 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M17 9H1" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M9 17V1" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
);

PlusIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

export default PlusIcon; 
